import CuvamaAI from "./CuvamaAI";

export default CuvamaAI;
